import React, { useRef } from 'react';
import Edit from './Edit';
// import status from constants
import {
  FINISHED,
  CANCELLED,
  PASSED,
  FAILED,
  EDITED,
} from '../../../Constants/constants';
import Delete from './Delete';
import Schedule from './Schedule';
import { IoDuplicateSharp } from 'react-icons/io5';
import { IoMdMenu } from 'react-icons/io';

import { ListBox } from 'primereact/listbox';
import './OtherOptionsMenu.css';
import { Tooltip } from 'primereact/tooltip';
import { OverlayPanel } from 'primereact/overlaypanel';

export default function OtherOptionsMenu({
  props,
  deleteSingleClickHandler,
  scheduleSingleClickHandler,
  isAdmin,
  roles,
  isATCTable,
  userOwnsTest,
  editRoute,
  threeDotsTemplate,
}) {
  const overlayPanelRef = useRef(null);
  const buttonRef = useRef(null);

  const options = [
    {
      icon: (
        <Edit
          testId={props.id}
          testStatus={props.status}
          userOwnsTest={isAdmin || props.userOwnsTest}
          editRoute={editRoute}
          isATCTable={isATCTable}
        />
      ),
      text: 'Edit',
      disabled: !(
        userOwnsTest &&
        !isATCTable &&
        [CANCELLED, FINISHED, PASSED, FAILED, EDITED].includes(props.status)
      ),
      onClick: () => {
        window.location.href = `${editRoute}/${props.id}`;
      },
    },
    {
      icon: (
        <Delete
          testId={props.id}
          testStatus={props.status}
          userOwnsTest={isAdmin || props.userOwnsTest}
          deleteSingleClickHandler={deleteSingleClickHandler}
        />
      ),
      text: 'Delete',
      disabled: !(
        userOwnsTest &&
        [CANCELLED, FINISHED, PASSED, FAILED, EDITED].includes(props.status)
      ),
      onClick: (event) => {
        return deleteSingleClickHandler(event, props.id);
      },
    },
    {
      icon: (
        <Schedule
          testId={props.id}
          testStatus={props.status}
          userOwnsTest={isAdmin || props.userOwnsTest}
          isATCTable={isATCTable}
          roles={roles}
          isScheduled={props.isScheduled}
          scheduleSingleClickHandler={scheduleSingleClickHandler}
        />
      ),
      text: 'Schedule',
      disabled: !(
        [FINISHED, PASSED, FAILED, CANCELLED].includes(props.status) &&
        !isATCTable &&
        roles.includes('admin')
      ),
      onClick: (event) => {
        return scheduleSingleClickHandler(event, props.id);
      },
    },
    {
      icon: <IoDuplicateSharp className='actions-icon' />,
      text: 'Duplicate',
      disabled: isATCTable,
      onClick: (event) => {
        window.location.href = `/trfx-run-tests-duplicate/${props.id}`;
      },
    },
  ];

  const itemTemplate = (option) => {
    return (
      <div
        onClick={option.onClick}
        className={option.disabled ? 'p-disabled' : ''}
      >
        {option.icon} {option.text}
      </div>
    );
  };

  const toggle = (event) => {
    overlayPanelRef.current.toggle(event);
  };

  return (
    <div className='other-options-container'>
      <button
        ref={buttonRef}
        className={'att-threedots ml-auto other-options-button'}
        onClick={toggle}
      >
        <IoMdMenu size={20} className='actions-icon' />
      </button>

      <OverlayPanel ref={overlayPanelRef} className='other-options-overlay'>
        <ListBox
          options={options}
          itemTemplate={itemTemplate}
          className='other-options-menu-listbox'
        />
      </OverlayPanel>
    </div>
  );
}
